<template>
  <div v-cloak id="kt_portlet_tools_1"
       class="kt-portlet"
       data-ktportlet="true">
    <div class="kt-portlet__head">
      <div class="kt-portlet__head-label">
        <h3 class="kt-portlet__head-title">
          Configurations
        </h3>
      </div>
      <div class="kt-portlet__head-toolbar">
        <div class="kt-portlet__head-group">
          <div class="addNewEpgItemBtn">
            <button
              class="btn btn-info kt-btn kt-btn--air kt-btn--pill"
              @click="addNewEpgItem">
              New +
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="kt-portlet__body">
      <div class="kt-portlet__content">
        <div id="m_widget5_tab1_content" aria-expanded="true">
          <div class="kt-widget5">
            <div v-for="item in epg_items" :key="item.uuid" class="kt-widget5__item">
              <div class="kt-widget5__content">
                <div class="kt-widget5__section">
                  <h4 class="kt-widget5__title">
                    <a :href="`epg/${item.uuid}/edit`">{{ item.name }}</a>
                  </h4>
                  <span class="kt-widget5__desc">{{ item.sample || 'No sample provided!' }}</span> ->
                  <span class="kt-widget5__desc">
                    <span style="color:red">{{ item.source || 'No source provided!' }}</span>
                  </span>
                </div>
              </div>
              <div style="text-align: center;" class="kt-widget5__content">
                <div class="kt-widget5__stats1">
                  <a :href="`epg/${item.uuid}/edit`" class="btn btn-ss-standout kt-btn kt-btn--icon">
                    <span>
                      <i class="fa fa-pen" />
                      <span>Configure</span>
                    </span>
                  </a>
                </div>
                <div class="kt-widget5__stats1">
                  <a target="_blank"
                     :href="'epg/' + item.uuid"
                     class="btn btn-ss kt-btn kt-btn--icon">
                    <span>
                      <i class="fa fa-eye" />
                      <span>Preview</span>
                    </span>
                  </a>
                </div>
                <div class="kt-widget5__stats1">
                  <button class="btn btn-ss-danger kt-btn kt-btn--icon"
                          @click="deleteScheduleItem(item.uuid)">
                    <span>
                      <i class="fa fa-trash" />
                      <span>Delete</span>
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "pinia";
import useEpgStore from "VueStore/app/epg";

export default {
  name: "Epg",
  computed: {
    ...mapState(useEpgStore, ['epg_items']),
  },
  mounted() {
    this.fetchEpgItems();
  },
  methods: {
    ...mapActions(useEpgStore, [
      'fetchEpgItems',
      'addEpgItem',
      'deleteEpgItem',
    ]),
    addNewEpgItem: _.debounce(() => {
      (async function () {
        const { value: name } = await swal.fire({
          title: "Give it a name",
          input: "text",
          inputPlaceholder: "",
          showCancelButton: true,
          allowOutsideClick: false,
          inputValidator: value => !value && "Cannot be blank!",
        });
        if (name) {
          this.addEpgItem(name);
        }
      })();
    }, 1000),

    // delete the schedule object
    deleteScheduleItem(uuid) {
      swal
        .fire({
          title: "Are you sure?",
          text: "It will be gone forever!",
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, delete it!",
          cancelButtonText: "No, keep it",
        })
        .then((result) => {
          if (result.value) {
            this.deleteEpgItem(uuid);
            this.fetchEpgItems();
          }
        })
        .catch(swal.noop);
    },
  },
};
</script>

<style lang="scss">
[v-cloak] {
  display: none;
}

.popover-title {
  color: black;
}

.addNewScheduleItemBtn {
  padding-top: 10px;
  padding-bottom: 15px;
}

html {
  overflow-x: hidden;
}
</style>
